import React from "react";
import {IonItem, IonLabel, IonTextarea, TextareaChangeEventDetail} from "@ionic/react";
import './CommentaryForm.css';
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    /**
     * Comment displayed in the textarea.
     * If undefined, the default value is empty.
     */
    currentCommentary?: string,
    /**
     * Function called when there is a change in the textarea.
     * @param {string} commentary New comment filled in by the user. Can be undefined or null if the props required is not true.
     */
    onCommentaryChange?: (commentary?: string | null) => void,
    /**
     * Specifies if the field is required and if the value entered can be null or empty.
     * @default false
     */
    required?: boolean,
    /**
     * Item class name.
     */
    className?: string,
}

/**
 * Component with an item with a label and a textarea.
 * @author Alizée Grand
 * @version 1.1
 * @creation 28/03/2022
 * @last_update 20/04/2022
 **/
class CommentaryForm extends React.Component<Props>{

    state = {
        commentary: this.props.currentCommentary !== undefined ? this.props.currentCommentary : "",
    }

    render() {

        /**
* Retrieves from the props the function to access the translation.
**/
const getTranslation = this.props.t;

        /**
         * Function called when there is a change in the textarea.
         * Stores the new field value in the component and calls the corresponding function passed in props if it exists.
         * @param {CustomEvent<TextareaChangeEventDetail>} e Change event in the textarea.
         */
        const onCommentaryChange = (e: CustomEvent<TextareaChangeEventDetail>) => {
            const comment = e.detail.value;
            if(this.props.required && !comment) {
                // Nothing
            } else {
                this.setState({commentary: comment});
                if(this.props.onCommentaryChange) {
                    this.props.onCommentaryChange(comment);
                }
            }
        }

        return (
            <IonItem id="commentary-form-item" className={this.props.className}>
                <IonLabel position="floating">{getTranslation("steps.comment.label")} {this.props.required ? "*" : ""}</IonLabel>
                <IonTextarea
                    onIonChange={(e) => {onCommentaryChange(e)}}
                    autoGrow={true}
                    placeholder={getTranslation("steps.comment.placeholder")}
                    value={this.state.commentary}
                    id="commentary-form-textarea"
                    required={this.props.required}
                />
            </IonItem>
        );

    };

}

export default withTranslation()(CommentaryForm);
